import './MetricsPage.css';
import './App.css';
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import "@fontsource/oswald";
import {XAxis, XYPlot, YAxis, VerticalGridLines, HorizontalGridLines, LineSeries, RadialChart, LineMarkSeries, ArcSeries} from 'react-vis';
import {db} from './firebase';

// could potentailly 
/*
const graphData = () => {
  // some way of practicing adding data (using for logs first)
  const [logs, setLogs] = useState([]);

  // fetching logs from the firestore and sorting them by time (newest first)
  // can add filtering based on device id in the future
  const fetchPost = async () => {
      await getDocs(query(collection(db, "test-logs"), orderBy("time", "desc")))
          .then((querySnapshot)=>{              
              const newData = querySnapshot.docs
                  .map((doc) => ({...doc.data(), id:doc.id }));
              setLogs(newData);                
              console.log(logs, newData);
          })
     
  }
 
  useEffect(()=>{
      fetchPost();
  }, [])


  // have some way to input logs (for testing purposes to get them to show up)

  return (
      <section className="logs-container">
          <div className="log">
              <h1 className="header">
                  Feedback Logs
              </h1>

              <Table striped bordered hover size="sm" >
                  <thead>
                      <tr>
                      <th>Time Stamp</th>
                      <th>Feedback</th>
                      </tr>
                  </thead>
                  <tbody className="log-content">
                      {
                          logs.map((log,i)=>(
                              <tr key={i}>
                                  <td>{convertLogTime(log.time)}</td>
                                  <td>{log.log}</td>
                              </tr>
                          ))
                      }
                  </tbody>
              </Table>
          </div>
      </section>
  )
}
*/

// can call this with useEffect
function calculateDailyPercent(distractedInstances, totalSeconds) {
  // each instance represents looking away for 2s
  return (distractedInstances * 200) / totalSeconds
}

function MetricsPage(props) {
  
  const [valueColor, setValueColor] = useState("green");

  useEffect(() => {
    setValueColor("green");
  }, []);

  /*
  const arcData = [
    {angle0: 0, angle: Math.PI / 2, opacity: 0.2, radius: 2, radius0: 1},
    {angle0: 2 * Math.PI / 4, angle: 3 * Math.PI / 4, opacity: 0, radius: 2, radius0: 0},
  ]
  */

  // would calculate distracted % per day somewhere else based on existing data -- store this value in database after the day has passed?
  const data = [
    {x: new Date('01/01/2023'), y: 1.8},
    {x: new Date('01/08/2023'), y: 1.5},
    {x: new Date('01/015/2023'), y: 1.4},
    {x: new Date('01/022/2023'), y: 1.9},
    {x: new Date('01/29/2023'), y: 1},
    {x: new Date('02/04/2023'), y: 0.7},
    {x: new Date('02/11/2023'), y: 0.6},
    {x: new Date('02/18/2023'), y: 0.5},
    {x: new Date('02/25/2023'), y: 0.2}
  ];

  return (
    <div>
      <link rel="stylesheet" href="https://unpkg.com/react-vis/dist/style.css"></link>
      <table>
        <thead />
        <tbody>
          <tr>
            <td className="metrics-title">
              
            </td>
          </tr>
          <tr>
            <td >
              <div className="chart">
                Today's Percent of Driving Time Spent Distracted
                <div id="value" style={{color: valueColor}}>0.1%</div>
              </div>
            </td>
            <td rowSpan="2">
              <div className="graph">
                Percentage of Weekly Driving Time Spent Distracted
                <XYPlot xType="time" height={400} width= {700}>
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis />
                  <YAxis />
                  <LineMarkSeries data={data} style={{strokeWidth: 5}} color="#097969" />
                </XYPlot>
              </div>
            </td>
          </tr>
          <tr>
            <td className="logs-button">
              <Button variant="secondary" className="secondary; bigger" onClick={props.handleLogsButton}>View Logs</Button>
            </td>
          </tr>
        </tbody>
      </table>
      {/*
      <XYPlot
        xDomain={[-5, 5]}
        yDomain={[-5, 5]}
        width={300}
        height={300}>
        <ArcSeries data={arcData}/>
      </XYPlot>
      */}
    </div>
  );
}

export default MetricsPage;